import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

import {
  PresignedUrlUseCase,
  generatePresignedURL,
} from '../modules/uploader/UploaderActions';
import { uploadFileToS3 } from '../utils/api';

export const useStartFileUpload = (
  options?: UseMutationOptions<void, unknown, File[], unknown>,
) =>
  useMutation({
    mutationFn: async (filesArray: File[]) => {
      const presignedUrls = await Promise.all(
        filesArray.map(async (file) => {
          const url = await generatePresignedURL(
            file.name,
            uuidv4(),
            PresignedUrlUseCase.PPD_IMAGE_UPLOAD,
          );
          return {
            url: url?.uploadUrl,
            file,
          };
        }),
      );
      await Promise.all(
        presignedUrls.map(({ url, file }) => uploadFileToS3(url, file)),
      );
    },
    ...options,
  });
